/* HVAC-065-DI */
(function () {
  'use strict';

  var STORAGE_KEY = 'hvac-065-system-selector';
  var KLAVIYO_COMPANY_ID = 'QRMaqu';
  var KLAVIYO_METRIC_NAME = 'System Selector Results';

  var SYSTEM_TYPES = [
    {
      id: 'acFurnace',
      title: 'AC & Furnace',
      outdoor: 'AC',
      indoor: 'Furnace',
      image: 'AC condenser + gas furnace',
      included: ['Air conditioner', 'Gas furnace', 'Coil'],
    },
    {
      id: 'acCoil',
      title: 'AC & Coil',
      outdoor: 'AC',
      indoor: 'Coil',
      image: 'AC condenser + evaporator coil',
      included: ['Air conditioner', 'Evaporator coil', 'Pairs w/ your existing furnace'],
    },
    {
      id: 'acAirHandler',
      title: 'AC & Air Handler',
      outdoor: 'AC',
      indoor: 'Air Handler',
      image: 'AC condenser + air handler',
      included: ['Air conditioner', 'Air handler'],
    },
    {
      id: 'hpFurnace',
      title: 'Heat Pump & Furnace',
      outdoor: 'Heat Pump',
      indoor: 'Furnace',
      image: 'Heat pump + gas furnace',
      included: ['Heat pump', 'Gas furnace (dual fuel)', 'Coil'],
    },
    {
      id: 'hpAirHandler',
      title: 'Heat Pump & Air Handler',
      outdoor: 'Heat Pump',
      indoor: 'Air Handler',
      image: 'Heat pump + air handler',
      included: ['Heat pump', 'Air handler'],
    },
    {
      id: 'furnace',
      title: 'Natural Gas Furnace',
      outdoor: null,
      indoor: 'Furnace',
      image: 'Natural gas furnace',
      included: ['Natural Gas or Propane (Propane Conversion Kit Required)'],
    },
  ];

  var CABINET = [
    { id: '14', title: '14"', captions: ['Compact / closet units'] },
    { id: '17.5', title: '17.5"', captions: ['Most common width'] },
    { id: '21', title: '21"', captions: ['Mid-large systems'] },
    { id: '24.5', title: '24.5"', captions: ['Large / high-capacity'] },
  ];

  var BRANCH = {
    acFurnace: ['furnaceEff', 'cabinet', 'config', 'heatingStages'],
    acCoil: ['cabinet', 'config'],
    acAirHandler: ['cabinet', 'config', 'heatingStages'],
    hpAirHandler: ['cabinet'],
    hpFurnace: ['furnaceEff', 'config', 'heatingStages'],
    furnace: ['furnaceEff', 'config', 'cabinet', 'heatingStages'],
  };

  var OPTIONS = {
    furnaceEff: {
      acFurnace: [
        { id: '80', title: '80% AFUE', captions: ['Chimney vent'], image: '80% furnace — metal chimney vent' },
        { id: '92', title: '92% AFUE', captions: ['PVC vent'], image: '92% furnace — white PVC vent' },
        { id: '96', title: '96% AFUE', captions: ['PVC vent'], image: '96% furnace — white PVC vent' },
        { id: '97', title: '97% AFUE', captions: ['PVC vent · top tier'], image: '97% furnace — white PVC vent' },
      ],
      hpFurnace: [
        { id: '80', title: '80% AFUE', captions: ['Chimney vent'], image: '80% furnace — metal chimney vent' },
        { id: '92', title: '92% AFUE', captions: ['PVC vent'], image: '92% furnace — white PVC vent' },
        { id: '96', title: '96% AFUE', captions: ['PVC vent'], image: '96% furnace — white PVC vent' },
      ],
      furnace: [
        { id: '80', title: '80% AFUE', captions: ['Chimney vent'], image: '80% furnace — metal chimney vent' },
        { id: '92', title: '92% AFUE', captions: ['PVC vent'], image: '92% furnace — white PVC vent' },
        { id: '96', title: '96% AFUE', captions: ['PVC vent'], image: '96% furnace — white PVC vent' },
        { id: '97', title: '97% AFUE', captions: ['PVC vent · top tier'], image: '97% furnace — white PVC vent' },
      ],
    },
    config: {
      acFurnace: [
        { id: 'horizontal', title: 'Horizontal', captions: ['Best for attics, crawlspaces, tight spots'], image: 'horizontal install' },
        { id: 'upflow', title: 'Upflow', captions: ['Best for basements & utility closets'], image: 'upflow install' },
        { id: 'downflow', title: 'Downflow', captions: ['Best for attics & upper floors'], image: 'downflow install' },
        { id: 'multi', title: 'Multi-positional', captions: ['Flexible — installs any orientation'], image: 'multi-positional install' },
      ],
      acCoil: [
        { id: 'vertical', title: 'Vertical (Up/Down)', captions: ['Best for closets & narrow spaces'], image: 'vertical coil install' },
        { id: 'horizontal', title: 'Horizontal', captions: ['Best for attics & crawlspaces'], image: 'horizontal coil install' },
        { id: 'multi', title: 'Multi-positional', captions: ['Flexible — any orientation'], image: 'multi-positional coil' },
      ],
      acAirHandler: [{ id: 'multi', title: 'Multi-Positional', captions: ['Flexible — any orientation'], image: 'multi-positional air handler' }],
      hpFurnace: [
        { id: 'horizontal', title: 'Horizontal', captions: ['Best for attics & crawlspaces'], image: 'horizontal install' },
        { id: 'upflow', title: 'Upflow', captions: ['Best for basements & closets'], image: 'upflow install' },
        { id: 'downflow', title: 'Downflow', captions: ['Best for attics & upper floors'], image: 'downflow install' },
      ],
      furnace: [
        {
          id: 'downflow',
          title: 'Downflow / Horizontal',
          captions: ['Best for attics and crawl spaces where airflow is downward or horizontal'],
          image: 'furnace horizontal downflow install',
        },
        {
          id: 'upflow',
          title: 'Upflow / Horizontal',
          captions: ['Best for basements where airflow is upward or horizontal'],
          image: 'furnace horizontal upflow install',
        },
        {
          id: 'multi',
          title: 'Multi-positional',
          captions: ['Flexible installation in multiple positions'],
          image: 'furnace multi-positional install',
        },
      ],
    },
    heatingStages: {
      acFurnace: [
        { id: 'single', title: 'Single Stage', captions: ['One fixed output', 'Most affordable'] },
        { id: 'two', title: 'Two Stage', captions: ['High / low output', 'Better comfort'] },
        {
          id: 'twoModVar',
          title: 'Two-Stage Modulating Variable-Speed',
          captions: ['Finest temperature control'],
        },
        { id: 'twoVar', title: 'Two-Stage Variable-Speed', captions: ['Quiet, even airflow'] },
      ],
      acAirHandler: [{ id: 'single', title: 'Single Stage', captions: ['Standard air handler'] }],
      hpFurnace: [
        { id: 'single', title: 'Single Stage', captions: ['One fixed output'] },
        { id: 'two', title: 'Two Stage', captions: ['High / low output'] },
      ],
      furnace: [
        { id: 'single', title: 'Single stage', captions: ['One heat output level. It’s either on or off.'] },
        { id: 'two', title: 'Two stages', captions: ['Runs on low or high heat depending on demand.'] },
        {
          id: 'twoModVar',
          title: 'Two stages modulating variable speed',
          captions: ['Advanced comfort with staged heating and highly adaptive airflow control.'],
        },
        {
          id: 'twoVar',
          title: 'Two stages variable speed',
          captions: ['Two heat levels with variable speed blower for more consistent comfort.'],
        },
      ],
    },
  };

  var TON_STEPS = [1.5, 2, 2.5, 3, 3.5, 4, 5];
  var ZONES = [
    { id: 'z1', title: 'Zone 1', color: '#E4002B', captions: ['Hot South · S. FL, S. TX'], factorLo: 30, factorHi: 35, tons: [900, 1200, 1500, 1800, 2100, 2400, 3000] },
    { id: 'z2', title: 'Zone 2', color: '#F57C1F', captions: ['Warm · Gulf, AZ, S. CA'], factorLo: 35, factorHi: 40, tons: [950, 1250, 1550, 1850, 2150, 2500, 3100] },
    { id: 'z3', title: 'Zone 3', color: '#F5C400', captions: ['Mixed · mid-US, mid-Atl.'], factorLo: 40, factorHi: 45, tons: [1000, 1300, 1600, 1900, 2200, 2600, 3200] },
    { id: 'z4', title: 'Zone 4', color: '#3C8A3F', captions: ['Cool · Great Lakes, Plains'], factorLo: 45, factorHi: 50, tons: [1050, 1350, 1600, 2000, 2250, 2700, 3300] },
    { id: 'z5', title: 'Zone 5', color: '#1B54B3', captions: ['Cold · Northern US'], factorLo: 50, factorHi: 60, tons: [1100, 1400, 1650, 2100, 2300, 2700, 3300] },
  ];
  var INSULATION = [
    {
      id: 'good',
      title: 'Well Insulated',
      captions: ['Newer or well-sealed home', 'Good windows, solid attic insulation', 'Uses the lower BTU factor'],
    },
    {
      id: 'poor',
      title: 'Poorly Insulated',
      captions: ['Older or drafty home', 'Aging or many windows', 'Uses the higher BTU factor · pick if unsure'],
    },
  ];
  var BRANDS = [
    { id: 'goodman', title: 'Goodman', captions: ['Reliable, widely serviced'] },
    { id: 'aciq', title: 'ACiQ', captions: ['Premium efficiency options'] },
    { id: 'none', title: 'Best Deal', captions: ['We pick the lowest-priced compatible system'] },
  ];
  var TONNAGE = [
    { ton: 1.5, btu: 18000 },
    { ton: 2, btu: 24000 },
    { ton: 2.5, btu: 30000 },
    { ton: 3, btu: 36000 },
    { ton: 3.5, btu: 42000 },
    { ton: 4, btu: 48000 },
    { ton: 5, btu: 60000 },
  ];
  var HEATING = [40000, 60000, 80000, 100000, 120000];

  var STEP_META = {
    zone: {
      label: 'Zone',
      title: 'Select Your Zone',
      sub: 'Your climate zone sets how much heating and cooling your home needs. Choose the region that matches your climate.',
    },
    sqft: {
      label: 'Home Size',
      title: 'Home Size & Insulation',
      sub: 'Enter your square footage and tell us how well your home is insulated — together these size your system.',
    },
    insulation: {
      label: 'Insulation',
      title: 'Insulation Quality',
      sub: 'How well does your home hold temperature? This fine-tunes the sizing.',
    },
    systemType: {
      label: 'System',
      title: 'Choose Your System Type',
      sub: '',
    },
    furnaceEff: {
      label: 'Efficiency',
      title: 'Furnace Efficiency',
      sub: 'Higher AFUE furnaces save fuel. Vent type is how you tell what you have.',
    },
    cabinet: {
      label: 'Cabinet',
      title: 'Cabinet Width',
      sub: 'Match the width of your existing indoor unit.',
    },
    config: {
      label: 'Config',
      title: 'Configuration',
      sub: 'How the unit sits determines airflow direction.',
    },
    heatingStages: {
      label: 'Stages',
      title: 'Heating Stages',
      sub: 'More stages mean quieter, more even, more efficient heat.',
    },
    brand: {
      label: 'Brand',
      title: 'Choose Your Brand',
      sub: 'We never mix brands within one system.',
    },
  };

  function emptyAnswers() {
    return {
      zone: null,
      zip: '',
      sqft: null,
      insulation: null,
      systemType: null,
      furnaceEff: null,
      cabinet: null,
      config: null,
      heatingStages: null,
      brand: null,
      tonnageOverride: null,
      heatingOverride: null,
    };
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function absoluteUrl(path) {
    if (!path) return '';
    var url = String(path);
    if (/^https?:\/\//i.test(url)) return url;
    // Shopify image_url is often protocol-relative: //hvactotal.com/cdn/...
    if (url.indexOf('//') === 0) {
      return (window.location.protocol || 'https:') + url;
    }
    return window.location.origin + (url.charAt(0) === '/' ? url : '/' + url);
  }

  function formatNum(n) {
    return Number(n).toLocaleString();
  }

  function getMeta(product, key) {
    if (!product) return null;
    if (product.metafields && product.metafields[key] != null) return product.metafields[key];
    if (product[key] != null) return product[key];
    return null;
  }

  function parseTonnage(value) {
    if (value == null || value === '') return null;
    var n = parseFloat(String(value).replace(/[^\d.]/g, ''));
    return isNaN(n) ? null : n;
  }

  function parseBTU(value) {
    if (value == null || value === '') return null;
    var s = String(value).toLowerCase();
    var n = parseFloat(s.replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return null;
    if (s.indexOf('k') !== -1 && n < 1000) n = n * 1000;
    return n;
  }

  /* HVAC-065-DI — results BOM must follow the matched product, not calc() */
  function parseTonnageFromTitle(title) {
    if (!title) return null;
    var m = String(title).match(/(\d+(?:\.\d+)?)\s*Ton/i);
    if (!m) return null;
    var n = parseFloat(m[1]);
    return isNaN(n) ? null : n;
  }

  function productDisplaySpecs(product, calc) {
    var spec = {
      ton: calc && calc.ton != null ? calc.ton : null,
      btu: calc && calc.btu != null ? calc.btu : null,
      furnaceInput: calc && calc.furnaceInput != null ? calc.furnaceInput : null,
    };
    if (!product) return spec;

    var ton = parseTonnage(getMeta(product, 'system_tonnage') || getMeta(product, 'cooling_capacity_tons_'));
    if (ton == null) ton = parseTonnageFromTitle(product.title);
    if (ton != null) {
      spec.ton = ton;
      spec.btu = Math.round(ton * 12000);
    }

    var heat = parseBTU(getMeta(product, 'heating_capacity_btus_'));
    if (heat != null) spec.furnaceInput = heat;
    return spec;
  }

  function vendorMatches(productVendor, brandId) {
    if (!brandId || brandId === 'none') return true;
    var v = String(productVendor || '')
      .toLowerCase()
      .replace(/[\s/_-]+/g, '');
    if (brandId === 'goodman') return v.indexOf('goodman') !== -1;
    if (brandId === 'aciq') return v.indexOf('aciq') !== -1;
    return true;
  }

  function hasMetaValue(value) {
    return value != null && String(value).trim() !== '';
  }

  function metafieldIncludes(value, needle) {
    if (value == null || needle == null) return false;
    return String(value).toLowerCase().indexOf(String(needle).toLowerCase()) !== -1;
  }

  /* Exact cabinet width match — avoids "21" matching "210" / partial inches */
  function cabinetWidthMatches(meta, widthId) {
    if (!hasMetaValue(meta) || widthId == null || widthId === '') return false;
    var target = parseFloat(String(widthId));
    if (isNaN(target)) return metafieldIncludes(meta, widthId);
    var re = /(\d+(?:\.\d+)?)/g;
    var chunk = String(meta);
    var m;
    while ((m = re.exec(chunk))) {
      if (Math.abs(parseFloat(m[1]) - target) < 0.051) return true;
    }
    return false;
  }

  var TRIAL_META_KEYS = {
    furnaceEff: 'furnace_efficiency_',
    cabinet: 'evaporator_coil_width',
    config: 'configuration_new',
    heatingStages: 'heating_stages',
  };

  function stagesMatches(meta, stagesId) {
    if (!stagesId) return true;
    if (!hasMetaValue(meta)) return false;
    var m = String(meta).toLowerCase();
    var hasVar = m.indexOf('variable') !== -1;
    var hasMod = m.indexOf('modulat') !== -1;
    if (stagesId === 'single') {
      return m.indexOf('single') !== -1 && m.indexOf('two') === -1;
    }
    if (stagesId === 'two') {
      return m.indexOf('two') !== -1 && !hasVar && !hasMod;
    }
    if (stagesId === 'twoVar') {
      return hasVar && !hasMod;
    }
    if (stagesId === 'twoModVar') {
      return hasMod;
    }
    return metafieldIncludes(meta, stagesId);
  }

  function configMatches(meta, configId) {
    if (!configId) return true;
    if (!hasMetaValue(meta)) return false;
    var m = String(meta).toLowerCase();
    if (configId === 'multi') return m.indexOf('multi') !== -1;
    if (configId === 'vertical') return m.indexOf('vertical') !== -1;
    if (configId === 'upflow') return m.indexOf('upflow') !== -1;
    if (configId === 'downflow') return m.indexOf('downflow') !== -1;
    if (configId === 'horizontal') {
      return m.indexOf('horizontal') !== -1;
    }
    return metafieldIncludes(meta, configId);
  }

  function catalogProducts(config, systemType, brandId) {
    var collections = (config && config.collections) || {};
    var col = collections[systemType];
    if (!col || !col.products || !col.products.length) return [];
    return col.products.filter(function (p) {
      return vendorMatches(p.vendor || p.title, brandId);
    });
  }

  /* HVAC-065-DI — missing metafields do not reject; present mismatches do */
  function productMatchesTrial(product, trial, calc) {
    if (!product) return false;
    if (!vendorMatches(product.vendor || product.title, trial.brand)) return false;

    if (trial.furnaceEff) {
      var eff = getMeta(product, 'furnace_efficiency_');
      if (hasMetaValue(eff) && !metafieldIncludes(eff, trial.furnaceEff)) return false;
    }
    if (trial.cabinet) {
      var cabinet = getMeta(product, 'evaporator_coil_width');
      if (hasMetaValue(cabinet) && !cabinetWidthMatches(cabinet, trial.cabinet)) return false;
    }
    if (trial.config) {
      var configMeta = getMeta(product, 'configuration_new');
      if (hasMetaValue(configMeta) && !configMatches(configMeta, trial.config)) return false;
    }
    if (trial.heatingStages) {
      var stages = getMeta(product, 'heating_stages');
      if (hasMetaValue(stages) && !stagesMatches(stages, trial.heatingStages)) return false;
    }

    if (calc && calc.hasCooling && calc.ton != null) {
      var ton = parseTonnage(
        getMeta(product, 'system_tonnage') || getMeta(product, 'cooling_capacity_tons_')
      );
      if (ton != null && Math.abs(ton - calc.ton) > 0.26) return false;
    }
    if (calc && calc.hasFurnace && calc.furnaceInput != null) {
      var heat = parseBTU(getMeta(product, 'heating_capacity_btus_'));
      if (heat != null && Math.abs(heat - calc.furnaceInput) > 20000) return false;
    }

    return true;
  }

  function productSupportsOption(product, trialKey, optId, trial, calc) {
    if (!product) return false;
    var metaKey = TRIAL_META_KEYS[trialKey];
    if (!metaKey) return true;
    var meta = getMeta(product, metaKey);
    if (!hasMetaValue(meta)) return false;

    var probe = {};
    Object.keys(trial || {}).forEach(function (k) {
      probe[k] = trial[k];
    });
    probe[trialKey] = optId;

    if (trialKey === 'furnaceEff') {
      if (!metafieldIncludes(meta, optId)) return false;
    } else if (trialKey === 'cabinet') {
      if (!cabinetWidthMatches(meta, optId)) return false;
    } else if (trialKey === 'config') {
      if (!configMatches(meta, optId)) return false;
    } else if (trialKey === 'heatingStages') {
      if (!stagesMatches(meta, optId)) return false;
    }

    return productMatchesTrial(product, probe, calc);
  }

  function scoreProduct(product, a, calc) {
    var score = 0;
    var ton = parseTonnage(getMeta(product, 'system_tonnage') || getMeta(product, 'cooling_capacity_tons_'));
    var heat = parseBTU(getMeta(product, 'heating_capacity_btus_'));
    var eff = getMeta(product, 'furnace_efficiency_');
    var cabinet = getMeta(product, 'evaporator_coil_width');
    var config = getMeta(product, 'configuration_new');
    var stages = getMeta(product, 'heating_stages');

    if (calc && calc.hasCooling && calc.ton != null && ton != null) {
      var tonDiff = Math.abs(ton - calc.ton);
      score += Math.max(0, 100 - tonDiff * 40);
      if (tonDiff === 0) score += 40;
    }
    if (calc && calc.hasFurnace && calc.furnaceInput != null && heat != null) {
      var heatDiff = Math.abs(heat - calc.furnaceInput);
      score += Math.max(0, 80 - heatDiff / 1000);
      if (heatDiff === 0) score += 30;
    }
    if (a.furnaceEff && metafieldIncludes(eff, a.furnaceEff)) score += 35;
    if (a.cabinet && cabinetWidthMatches(cabinet, a.cabinet)) score += 25;
    if (a.config && metafieldIncludes(config, a.config)) score += 25;
    if (a.heatingStages && stagesMatches(stages, a.heatingStages)) score += 20;
    if (product.available) score += 10;
    return score;
  }

  function matchProduct(config, a, calc) {
    var collections = (config && config.collections) || {};
    var col = collections[a.systemType];
    if (!col || !col.products || !col.products.length) return null;

    var pool = col.products.filter(function (p) {
      return vendorMatches(p.vendor || p.title, a.brand);
    });
    /* HVAC-065-DI — explicit brand stays on that vendor; never leak Goodman into ACiQ */
    if (!pool.length) return null;

    var compatible = pool.filter(function (p) {
      return productMatchesTrial(p, a, calc);
    });
    if (!compatible.length) {
      compatible = pool.filter(function (p) {
        return productMatchesTrial(p, a, null);
      });
    }
    if (compatible.length) pool = compatible;

    /* Best Deal: lowest-priced compatible kit, not highest score */
    if (a.brand === 'none') {
      pool = pool.slice().sort(function (x, y) {
        return (x.price || 0) - (y.price || 0);
      });
      return pool[0] || null;
    }

    var ranked = pool
      .map(function (p) {
        return { product: p, score: scoreProduct(p, a, calc) };
      })
      .sort(function (x, y) {
        if (y.score !== x.score) return y.score - x.score;
        return (x.product.price || 0) - (y.product.price || 0);
      });

    return ranked.length ? ranked[0].product : null;
  }

  function buildCompatUrl(config, a, calc, product) {
    var collections = (config && config.collections) || {};
    var col = collections[a.systemType];
    var base = (col && col.url) || (config && config.compatibleCollectionUrl) || '';
    if (!base) return product && product.url ? product.url : '/collections/all';

    var params = [];
    if (a.brand === 'goodman') params.push('filter.p.vendor=Goodman');
    if (a.brand === 'aciq') params.push('filter.p.vendor=ACiQ');
    if (calc && calc.hasCooling && calc.ton != null) {
      params.push('filter.p.m.custom.system_tonnage=' + encodeURIComponent(String(calc.ton) + ' Ton'));
    }
    if (a.furnaceEff) {
      params.push('filter.p.m.custom.furnace_efficiency_=' + encodeURIComponent(a.furnaceEff + '%'));
    }
    if (a.cabinet) {
      params.push('filter.p.m.custom.evaporator_coil_width=' + encodeURIComponent(a.cabinet + '"'));
    }
    return params.length ? base + (base.indexOf('?') === -1 ? '?' : '&') + params.join('&') : base;
  }

  function formatMoneyCents(cents, fallback) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.theme && theme.moneyFormat) {
      try {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      } catch (e) {}
    }
    if (fallback) return fallback;
    var dollars = (Number(cents) || 0) / 100;
    return '$' + dollars.toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  function addVariantToCart(variantId) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var cartAddUrl =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add' : '/cart/add');

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sectionIds = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    }).then(function (response) {
      return response.json().then(function (data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Unable to add to cart');
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'system-selector-wizard',
            productVariantId: variantId,
            cartData: data,
          });
        }
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else if (cart && typeof cart.open === 'function') {
          return fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + '?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) {
              return r.json();
            })
            .then(function (sections) {
              cart.classList.remove('is-empty');
              cart.renderContents({ sections: sections }, true);
            });
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        return data;
      });
    });
  }

  function SystemSelectorWizard(root, config) {
    this.root = root;
    this.config = config || {};
    this.state = {
      idx: 0,
      isMobile: window.innerWidth < 1024,
      mobileSummaryOpen: false,
      overrideOpen: false,
      showResults: false,
      cartAdded: false,
      cartError: null,
      emailValue: '',
      emailSent: false,
      emailError: null,
      emailSending: false,
      financeOpen: false,
      a: emptyAnswers(),
    };
    this._onResize = this._onResize.bind(this);
    this._onRootClick = this._onRootClick.bind(this);
    this._onRootChange = this._onRootChange.bind(this);
    this._onRootInput = this._onRootInput.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
  }

  SystemSelectorWizard.prototype.init = function () {
    window.addEventListener('resize', this._onResize);
    this.root.addEventListener('click', this._onRootClick);
    this.root.addEventListener('change', this._onRootChange);
    this.root.addEventListener('input', this._onRootInput);
    document.addEventListener('keydown', this._onKeydown);
    this.restoreState();
    this.render();
  };

  SystemSelectorWizard.prototype.persistState = function () {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          idx: this.state.idx,
          showResults: this.state.showResults,
          a: this.state.a,
          emailValue: this.state.emailValue || '',
        })
      );
    } catch (err) {
      /* ignore quota / private mode */
    }
  };

  SystemSelectorWizard.prototype.restoreState = function () {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var saved = JSON.parse(raw);
      if (!saved || typeof saved !== 'object') return;
      if (saved.a && typeof saved.a === 'object') {
        this.state.a = Object.assign(emptyAnswers(), saved.a);
      }
      if (typeof saved.idx === 'number' && saved.idx >= 0) this.state.idx = saved.idx;
      if (typeof saved.showResults === 'boolean') this.state.showResults = saved.showResults;
      if (typeof saved.emailValue === 'string') this.state.emailValue = saved.emailValue;
    } catch (err) {
      /* ignore bad payload */
    }
  };

  SystemSelectorWizard.prototype.clearPersistedState = function () {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      /* ignore */
    }
  };

  SystemSelectorWizard.prototype.destroy = function () {
    window.removeEventListener('resize', this._onResize);
    document.removeEventListener('keydown', this._onKeydown);
    this.teardownStickyAtc();
  };

  SystemSelectorWizard.prototype.teardownStickyAtc = function () {
    if (this._atcObserver) {
      this._atcObserver.disconnect();
      this._atcObserver = null;
    }
    if (this._atcViewportCleanup) {
      this._atcViewportCleanup();
      this._atcViewportCleanup = null;
    }
  };

  /* HVAC-065-DI — stick ATC only after its in-flow position leaves the viewport */
  SystemSelectorWizard.prototype.bindStickyAtc = function () {
    this.teardownStickyAtc();
    if (!this.state.isMobile || !this.state.showResults) return;
    if (typeof IntersectionObserver === 'undefined') return;

    var results = this.root.querySelector('.ssw-results');
    var anchor = this.root.querySelector('.ssw-price__atc-anchor');
    var sentinel = this.root.querySelector('.ssw-price__actions-sentinel');
    var actions = this.root.querySelector('.ssw-price__actions');
    if (!results || !anchor || !sentinel || !actions) return;

    /* BUG-001 — pin to visualViewport so ATC tracks mobile browser chrome show/hide */
    var pinToVisualViewport = function () {
      if (!actions.classList.contains('ssw-price__actions--stuck')) {
        actions.style.bottom = '';
        actions.style.left = '';
        actions.style.width = '';
        actions.style.right = '';
        return;
      }
      var vv = window.visualViewport;
      if (!vv) {
        actions.style.bottom = '0px';
        actions.style.left = '0';
        actions.style.right = '0';
        actions.style.width = '';
        return;
      }
      var gap = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      actions.style.bottom = gap + 'px';
      actions.style.left = vv.offsetLeft + 'px';
      actions.style.width = vv.width + 'px';
      actions.style.right = 'auto';
    };

    var sync = function (inView) {
      var stuck = !inView;
      actions.classList.toggle('ssw-price__actions--stuck', stuck);
      anchor.classList.toggle('is-stuck', stuck);
      results.classList.toggle('ssw-results--atc-stuck', stuck);
      pinToVisualViewport();
    };

    this._atcObserver = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        sync(!!(entry && entry.isIntersecting));
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );
    this._atcObserver.observe(sentinel);

    var onViewportChange = function () {
      pinToVisualViewport();
    };
    window.addEventListener('resize', onViewportChange);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', onViewportChange);
      window.visualViewport.addEventListener('scroll', onViewportChange);
    }
    this._atcViewportCleanup = function () {
      window.removeEventListener('resize', onViewportChange);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', onViewportChange);
        window.visualViewport.removeEventListener('scroll', onViewportChange);
      }
      actions.style.bottom = '';
      actions.style.left = '';
      actions.style.width = '';
      actions.style.right = '';
    };

    var rect = sentinel.getBoundingClientRect();
    var vvH = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var inView = rect.top < vvH && rect.bottom > 0;
    sync(inView);
  };

  /* HVAC-065-DI — mobile system-type carousel snaps to first card after innerHTML rebuild */
  SystemSelectorWizard.prototype.restoreSelectedOptionScroll = function () {
    var scroller = this.root.querySelector('.ssw-options--system');
    if (!scroller) return;
    var selected = scroller.querySelector('.ssw-option--selected');
    if (!selected) return;
    var pin = function () {
      var sRect = scroller.getBoundingClientRect();
      var cRect = selected.getBoundingClientRect();
      scroller.scrollLeft += cRect.left - sRect.left - 2;
    };
    pin();
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(pin);
  };

  SystemSelectorWizard.prototype.scrollToWizardTop = function () {
    var section =
      this.root.closest('[data-system-selector-wizard]') ||
      this.root.closest('.system-selector-wizard') ||
      this.root;
    if (!section || typeof section.scrollIntoView !== 'function') return;
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  SystemSelectorWizard.prototype._onResize = function () {
    var m = window.innerWidth < 1024;
    if (m !== this.state.isMobile) {
      this.state.isMobile = m;
      this.render();
      return;
    }
    this.bindStickyAtc();
  };

  SystemSelectorWizard.prototype._onKeydown = function (e) {
    if (e.key === 'Escape' && this.state.financeOpen) {
      this.state.financeOpen = false;
      this.render();
    }
  };

  SystemSelectorWizard.prototype.setAnswer = function (key, value) {
    this.state.a[key] = value;
    if (
      key === 'brand' ||
      key === 'furnaceEff' ||
      key === 'cabinet' ||
      key === 'config' ||
      key === 'heatingStages' ||
      key === 'zone' ||
      key === 'sqft' ||
      key === 'insulation'
    ) {
      this.pruneIncompatibleAnswers();
      this.applyAutoAnswers();
    }
  };

  SystemSelectorWizard.prototype.selectSystemType = function (id) {
    var a = this.state.a;
    a.systemType = id;
    a.furnaceEff = null;
    a.cabinet = null;
    a.config = null;
    a.heatingStages = null;
    this.applyAutoAnswers();
  };

  SystemSelectorWizard.prototype.resetAll = function () {
    this.state.idx = 0;
    this.state.showResults = false;
    this.state.overrideOpen = false;
    this.state.cartAdded = false;
    this.state.cartError = null;
    this.state.emailValue = '';
    this.state.emailSent = false;
    this.state.emailError = null;
    this.state.financeOpen = false;
    this.state.a = emptyAnswers();
    this.clearPersistedState();
  };

  SystemSelectorWizard.prototype.rawOptionsFor = function (key) {
    var a = this.state.a;
    switch (key) {
      case 'zone':
        return ZONES;
      case 'sqft':
        return INSULATION;
      case 'insulation':
        return INSULATION;
      case 'systemType':
        return SYSTEM_TYPES;
      case 'cabinet':
        return CABINET;
      case 'brand':
        return BRANDS;
      case 'furnaceEff':
      case 'config':
      case 'heatingStages':
        return (OPTIONS[key] && OPTIONS[key][a.systemType]) || [];
      default:
        return [];
    }
  };

  /* HVAC-065-DI — only show options that exist on catalog products for prior answers */
  SystemSelectorWizard.prototype.optionsFor = function (key) {
    var all = this.rawOptionsFor(key);
    if (!all.length) return all;

    var filterKeys = ['furnaceEff', 'cabinet', 'config', 'heatingStages'];
    if (filterKeys.indexOf(key) === -1) return all;

    var a = this.state.a;
    if (!a.systemType) return all;

    var pool = catalogProducts(this.config, a.systemType, a.brand);
    if (!pool.length) return all;

    var metaKey = TRIAL_META_KEYS[key];
    var poolHasData = pool.some(function (p) {
      return hasMetaValue(getMeta(p, metaKey));
    });
    if (!poolHasData) return all;

    var calc = this.calc();
    var branch = BRANCH[a.systemType] || [];
    var keyIdx = branch.indexOf(key);
    var prior = {
      brand: a.brand,
      systemType: a.systemType,
    };
    for (var i = 0; i < keyIdx; i++) {
      var pk = branch[i];
      if (a[pk]) prior[pk] = a[pk];
    }

    function filterWith(sizeCalc) {
      return all.filter(function (opt) {
        return pool.some(function (product) {
          return productSupportsOption(product, key, opt.id, prior, sizeCalc);
        });
      });
    }

    var filtered = filterWith(calc);
    if (!filtered.length) filtered = filterWith(null);
    /* When catalog has metafields, never re-expand to the full static list */
    return filtered;
  };

  SystemSelectorWizard.prototype.pruneIncompatibleAnswers = function () {
    var a = this.state.a;
    if (!a.systemType) return;
    var branch = BRANCH[a.systemType] || [];
    var keys = ['furnaceEff', 'cabinet', 'config', 'heatingStages'].filter(function (k) {
      return branch.indexOf(k) !== -1;
    });
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!a[k]) continue;
      var opts = this.optionsFor(k);
      var stillValid = opts.some(function (o) {
        return o.id === a[k];
      });
      if (!stillValid) {
        a[k] = null;
        for (var j = i + 1; j < keys.length; j++) a[keys[j]] = null;
      }
    }
  };

  SystemSelectorWizard.prototype.applyAutoAnswers = function () {
    var a = this.state.a;
    if (!a.systemType) return;
    var branch = BRANCH[a.systemType] || [];
    var keys = ['furnaceEff', 'cabinet', 'config', 'heatingStages'].filter(function (k) {
      return branch.indexOf(k) !== -1;
    });
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      var opts = this.optionsFor(k);
      if (opts.length === 1) a[k] = opts[0].id;
    }
  };

  SystemSelectorWizard.prototype.fullKeys = function () {
    var a = this.state.a;
    var pre = ['systemType'];
    if (!a.systemType) return pre;
    return pre.concat(['brand', 'zone', 'sqft']).concat(BRANCH[a.systemType] || []);
  };

  SystemSelectorWizard.prototype.isAutoStep = function (k) {
    return ['furnaceEff', 'cabinet', 'config', 'heatingStages'].indexOf(k) !== -1;
  };

  SystemSelectorWizard.prototype.visibleKeys = function () {
    var self = this;
    return this.fullKeys().filter(function (k) {
      var opts = self.optionsFor(k);
      if (opts.length === 0) return false;
      if (opts.length === 1 && self.isAutoStep(k)) return false;
      return true;
    });
  };

  SystemSelectorWizard.prototype.autoValue = function (k) {
    var o = this.optionsFor(k);
    return o.length === 1 ? o[0].id : this.state.a[k];
  };

  SystemSelectorWizard.prototype.stepMeta = function (k) {
    return STEP_META[k] || { label: k, title: k, sub: '' };
  };

  SystemSelectorWizard.prototype.answered = function (k) {
    var a = this.state.a;
    if (k === 'zone') return !!a.zone;
    if (k === 'sqft') return !!(a.sqft && a.insulation);
    return !!a[k];
  };

  SystemSelectorWizard.prototype.labelFor = function (k) {
    var a = this.state.a;
    var v = a[k];
    if (k === 'zone') {
      if (!a.zone) return '—';
      var z = ZONES.find(function (item) {
        return item.id === a.zone;
      });
      return z ? z.title : '—';
    }
    if (k === 'sqft') return a.sqft ? a.sqft + ' sq ft' : '—';
    if (!v) return '—';
    var o = this.optionsFor(k).find(function (item) {
      return item.id === v;
    });
    return o ? o.title : v;
  };

  SystemSelectorWizard.prototype.calc = function () {
    var a = this.state.a;
    if (!a.zone || !a.sqft || !a.insulation) return null;
    var zone =
      ZONES.find(function (z) {
        return z.id === a.zone;
      }) || ZONES[2];
    var st = SYSTEM_TYPES.find(function (t) {
      return t.id === a.systemType;
    });
    var hasCooling = !st || st.outdoor != null;
    var maxTon = a.systemType === 'hpFurnace' ? 3.5 : 5;
    var ti = zone.tons.findIndex(function (up) {
      return a.sqft <= up;
    });
    if (ti < 0) ti = TON_STEPS.length - 1;
    while (TON_STEPS[ti] > maxTon && ti > 0) ti--;
    if (a.tonnageOverride) {
      var oi = TON_STEPS.indexOf(a.tonnageOverride);
      if (oi >= 0) ti = oi;
    }
    var ton = hasCooling ? TON_STEPS[ti] : null;
    var btu = hasCooling ? ton * 12000 : null;
    var factor = a.insulation === 'good' ? zone.factorLo : zone.factorHi;
    var reqHeat = a.sqft * factor;
    var hasFurnace = st && st.indoor === 'Furnace';
    var eff = (a.furnaceEff ? parseInt(a.furnaceEff, 10) : 80) / 100;
    var reqInput = reqHeat / eff;
    var heatCap = a.systemType === 'hpFurnace' ? 100000 : 120000;
    var furnaceInput =
      HEATING.find(function (h) {
        return h >= reqInput && h <= heatCap;
      }) || heatCap;
    if (a.heatingOverride && HEATING.indexOf(a.heatingOverride) !== -1) furnaceInput = a.heatingOverride;
    return {
      ton: ton,
      btu: btu,
      factor: factor,
      reqHeat: reqHeat,
      eff: eff,
      furnaceInput: furnaceInput,
      furnaceOutput: Math.round(furnaceInput * eff),
      hasFurnace: hasFurnace,
      hasCooling: hasCooling,
      zoneTitle: zone.title,
    };
  };

  SystemSelectorWizard.prototype.resolveKit = function () {
    var a = this.state.a;
    var c = this.calc() || { ton: 2.5, btu: 30000, reqHeat: 60000, furnaceInput: 80000, hasCooling: true, hasFurnace: true };
    var st =
      SYSTEM_TYPES.find(function (t) {
        return t.id === a.systemType;
      }) || SYSTEM_TYPES[0];
    var product = matchProduct(this.config, a, c);
    var brand = a.brand;
    if (product && product.vendor) {
      var v = String(product.vendor).toLowerCase();
      if (v.indexOf('aciq') !== -1) brand = 'aciq';
      else if (v.indexOf('goodman') !== -1) brand = 'goodman';
    } else if (!brand || brand === 'none') {
      brand = 'goodman';
    }
    var brandName = product && product.vendor ? product.vendor : brand === 'aciq' ? 'ACiQ' : 'Goodman';
    var priceCents = product ? product.price : null;
    var priceDollars = priceCents != null ? Math.round(priceCents / 100) : null;
    var model = (product && (product.sku || product.handle)) || '—';
    var name =
      product && product.title
        ? product.title
        : outdoorName(st, c, brandName);
    var spec = productDisplaySpecs(product, c);
    return {
      st: st,
      c: c,
      spec: spec,
      brand: brand,
      brandName: brandName,
      price: priceDollars,
      priceCents: priceCents,
      priceFormatted: product ? product.price_formatted || formatMoneyCents(priceCents) : null,
      model: model,
      product: product,
      imageUrl: product && product.featured_image ? product.featured_image.url : null,
      imageAlt: product && product.featured_image ? product.featured_image.alt || product.title : '',
      productUrl: product ? product.url : null,
      variantId: product ? product.variant_id : null,
      available: product ? !!product.available : false,
      compatUrl: buildCompatUrl(this.config, a, c, product),
    };
  };

  function outdoorName(st, c, brandName) {
    if (!st.outdoor) {
      return brandName + ' ' + st.title + ' — ' + formatNum(c.furnaceInput || 60000) + ' BTU';
    }
    return brandName + ' ' + st.title + ' — ' + c.ton + ' Ton';
  }

  SystemSelectorWizard.prototype._onRootClick = function (e) {
    var t = e.target.closest('[data-action]');
    if (!t || !this.root.contains(t)) return;
    var action = t.getAttribute('data-action');
    var value = t.getAttribute('data-value');
    var a = this.state.a;
    var vis = this.visibleKeys();
    var idx = Math.min(this.state.idx, Math.max(vis.length - 1, 0));
    var curKey = vis[idx];

    switch (action) {
      case 'step':
        var stepIdx = parseInt(value, 10);
        if (!isNaN(stepIdx) && stepIdx <= idx) {
          this.state.idx = stepIdx;
          this.render();
        }
        break;
      case 'reset':
        this.resetAll();
        this.render();
        break;
      case 'skip':
        var firstUn = vis.findIndex(function (k) {
          return !this.answered(k);
        }.bind(this));
        if (firstUn < 0) this.state.showResults = true;
        else this.state.idx = firstUn;
        this.render();
        this.scrollToWizardTop();
        break;
      case 'select':
        if (curKey === 'sqft') this.setAnswer('insulation', value);
        else if (curKey === 'systemType') this.selectSystemType(value);
        else this.setAnswer(curKey, value);
        this.render();
        break;
      case 'toggle-override':
        this.state.overrideOpen = !this.state.overrideOpen;
        this.render();
        break;
      case 'toggle-summary':
        if (this.state.isMobile) {
          this.state.mobileSummaryOpen = !this.state.mobileSummaryOpen;
          this.render();
        }
        break;
      case 'back':
        if (idx > 0) {
          this.state.idx = idx - 1;
          this.render();
          this.scrollToWizardTop();
        }
        break;
      case 'next':
        if (!this.answered(curKey)) return;
        if (idx === vis.length - 1) this.state.showResults = true;
        else this.state.idx = idx + 1;
        this.render();
        this.scrollToWizardTop();
        break;
      case 'view-compat':
        if (vis.every(this.answered.bind(this))) {
          this.state.showResults = true;
          this.render();
          this.scrollToWizardTop();
        }
        break;
      case 'edit':
        this.state.showResults = false;
        this.render();
        this.scrollToWizardTop();
        break;
      case 'add-cart':
        this.addRecommendedToCart(t);
        break;
      case 'email':
        this.emailResults();
        break;
      case 'open-finance':
        this.state.financeOpen = true;
        this.render();
        break;
      case 'close-finance':
        this.state.financeOpen = false;
        this.render();
        break;
      case 'browse-compat':
        var kitBrowse = this.resolveKit();
        window.location.href = kitBrowse.compatUrl || kitBrowse.productUrl || '/collections/all';
        break;
      case 'view-product':
        var kitView = this.resolveKit();
        if (kitView.productUrl) window.location.href = kitView.productUrl;
        break;
      default:
        break;
    }
  };

  SystemSelectorWizard.prototype.buildAddToCartUrl = function (kit) {
    if (!kit || !kit.variantId) return kit && kit.productUrl ? absoluteUrl(kit.productUrl) : '';
    var root =
      (window.Shopify && Shopify.routes && Shopify.routes.root) ||
      (window.routes && window.routes.root) ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return window.location.origin + root + 'cart/' + kit.variantId + ':1';
  };

  SystemSelectorWizard.prototype.buildKlaviyoEventProperties = function (kit) {
    var a = this.state.a;
    var c = kit.c || {};
    var st = kit.st || {};
    var product = kit.product || null;
    var title = product && product.title ? product.title : outdoorName(st, c, kit.brandName);
    var model = kit.model || '—';
    var configLabel = this.labelFor('config');
    var stagesLabel = this.labelFor('heatingStages');
    var cabinetLabel = this.labelFor('cabinet');
    var outdoor = st.outdoor;
    var indoor = st.indoor;
    var spec = kit.spec || productDisplaySpecs(product, c);
    var primaryAc =
      outdoor && c.hasCooling !== false && spec.ton != null
        ? spec.ton + ' Ton · ' + formatNum(spec.btu || spec.ton * 12000) + ' BTU'
        : '';
    var primaryFurnace =
      indoor === 'Furnace'
        ? (a.furnaceEff || '80') + '% AFUE · ' + formatNum(spec.furnaceInput || c.furnaceInput || 0) + ' BTU'
        : indoor
          ? indoor
          : '';
    var refrigerant = '';
    if (product && product.metafields) {
      var rf =
        product.metafields.refrigerant ||
        product.metafields.refrigerant_type ||
        product.metafields.refrigerant_new;
      if (rf) refrigerant = String(rf);
    }

    return {
      Brand: kit.brandName || '',
      SystemTitle: title,
      ProductName: title,
      ProductID: product ? String(product.id) : '',
      VariantID: kit.variantId ? String(kit.variantId) : '',
      SKU: product && product.sku ? product.sku : '',
      ModelNumbers: model,
      Refrigerant: refrigerant,
      Configuration: configLabel !== '—' ? configLabel : '',
      Price: kit.price != null ? kit.price : kit.priceCents != null ? kit.priceCents / 100 : 0,
      PriceFormatted: kit.priceFormatted || '',
      Currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      ProductURL: kit.productUrl ? absoluteUrl(kit.productUrl) : '',
      ImageURL: kit.imageUrl ? absoluteUrl(kit.imageUrl) : '',
      AddToCartURL: this.buildAddToCartUrl(kit),
      CompatURL: kit.compatUrl ? absoluteUrl(kit.compatUrl) : '',
      PrimaryEquipmentAC: primaryAc,
      PrimaryEquipmentFurnace: primaryFurnace,
      PrimaryEquipmentCoil: outdoor && indoor !== 'Coil' ? 'Included' : indoor === 'Coil' ? 'Coil only' : '',
      HomeSize: a.sqft ? a.sqft + ' sq ft' : '',
      ClimateZone: this.labelFor('zone'),
      CabinetWidth: cabinetLabel !== '—' ? cabinetLabel : '',
      HeatingStages: stagesLabel !== '—' ? stagesLabel : '',
      SystemType: st.title || '',
      Insulation: this.labelFor('insulation'),
      ResultsURL: window.location.href.split('#')[0],
    };
  };

  SystemSelectorWizard.prototype.pushResultsToKlaviyo = function (email, kit) {
    var companyId = (this.config && this.config.klaviyoCompanyId) || KLAVIYO_COMPANY_ID;
    var metricName = (this.config && this.config.klaviyoMetricName) || KLAVIYO_METRIC_NAME;
    var properties = this.buildKlaviyoEventProperties(kit);
    var uniqueId =
      'ssr-' +
      Date.now() +
      '-' +
      Math.random().toString(36).slice(2, 10);
    var headers = {
      'Content-Type': 'application/json',
      revision: '2024-10-15',
    };

    function checkOk(res, label) {
      if (!res.ok) {
        return res.text().then(function (body) {
          throw new Error((label || 'Klaviyo request') + ' failed (' + res.status + '): ' + body);
        });
      }
      return res;
    }

    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: { email: email },
        },
      }),
    })
      .then(function (res) {
        return checkOk(res, 'Klaviyo profile');
      })
      .then(function () {
        return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                time: new Date().toISOString(),
                unique_id: uniqueId,
                metric: {
                  data: {
                    type: 'metric',
                    attributes: { name: metricName },
                  },
                },
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email },
                  },
                },
                properties: properties,
              },
            },
          }),
        });
      })
      .then(function (res) {
        return checkOk(res, 'Klaviyo event');
      })
      .then(function () {
        if (window.klaviyo && typeof window.klaviyo.push === 'function') {
          window.klaviyo.push(['identify', { $email: email }]);
          window.klaviyo.push(['track', metricName, properties]);
        } else if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['identify', { $email: email }]);
          window._learnq.push(['track', metricName, properties]);
        }
        return properties;
      });
  };

  SystemSelectorWizard.prototype.emailResults = function () {
    var email = String(this.state.emailValue || '').trim();
    if (!email || email.indexOf('@') < 1) {
      this.state.emailError = 'Enter a valid email address.';
      this.render();
      return;
    }
    var self = this;
    var kit = this.resolveKit();
    this.state.emailSending = true;
    this.state.emailError = null;
    this.render();
    this.pushResultsToKlaviyo(email, kit)
      .then(function () {
        self.state.emailSending = false;
        self.state.emailSent = true;
        self.state.emailError = null;
        self.persistState();
        self.render();
      })
      .catch(function () {
        self.state.emailSending = false;
        self.state.emailSent = false;
        self.state.emailError = 'Unable to send right now. Please try again.';
        self.render();
      });
  };

  SystemSelectorWizard.prototype.addRecommendedToCart = function (button) {
    var kit = this.resolveKit();
    var self = this;
    if (!kit.variantId) {
      if (kit.compatUrl || kit.productUrl) {
        window.location.href = kit.productUrl || kit.compatUrl;
      }
      return;
    }
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    this.state.cartError = null;
    addVariantToCart(kit.variantId)
      .then(function () {
        self.state.cartAdded = true;
        self.state.cartError = null;
        self.render();
      })
      .catch(function (err) {
        self.state.cartAdded = false;
        self.state.cartError = (err && err.message) || 'Unable to add to cart';
        self.render();
      });
  };

  SystemSelectorWizard.prototype.optionImageFor = function (curKey, opt) {
    var config = this.config || {};
    var optionImages = config.optionImages || {};
    var systemTypeImages = config.systemTypeImages || {};
    var systemType = this.state.a.systemType;
    if (curKey === 'systemType' && systemTypeImages[opt.id]) return systemTypeImages[opt.id];
    if (curKey === 'furnaceEff' && optionImages.furnaceEff) {
      if (opt.id === '80' && optionImages.furnaceEff.chimney) return optionImages.furnaceEff.chimney;
      if (opt.id !== '80' && optionImages.furnaceEff.pvc) return optionImages.furnaceEff.pvc;
    }
    if (curKey === 'config' && optionImages.config) {
      if (systemType === 'furnace') {
        if (opt.id === 'downflow' && optionImages.config.horizontalDownflow) {
          return optionImages.config.horizontalDownflow;
        }
        if (opt.id === 'upflow' && optionImages.config.horizontalUpflow) {
          return optionImages.config.horizontalUpflow;
        }
      }
      if (optionImages.config[opt.id]) return optionImages.config[opt.id];
    }
    if (curKey === 'heatingStages' && optionImages.heatingStages) {
      if (typeof optionImages.heatingStages === 'string') return optionImages.heatingStages;
      if (optionImages.heatingStages[opt.id]) return optionImages.heatingStages[opt.id];
    }
    return null;
  };

  SystemSelectorWizard.prototype.optionLogoFor = function (curKey, opt) {
    var brandImages = (this.config && this.config.brandImages) || {};
    if (curKey === 'brand' && brandImages[opt.id]) return brandImages[opt.id];
    return null;
  };

  SystemSelectorWizard.prototype._onRootChange = function (e) {
    var t = e.target;
    if (!t || !this.root.contains(t)) return;
    if (t.name === 'tonnageOverride') {
      this.setAnswer('tonnageOverride', t.value ? parseFloat(t.value) : null);
      this.render();
    } else if (t.name === 'heatingOverride') {
      this.setAnswer('heatingOverride', t.value ? parseInt(t.value, 10) : null);
      this.render();
    }
  };

  SystemSelectorWizard.prototype._onRootInput = function (e) {
    var t = e.target;
    if (!t || !this.root.contains(t)) return;
    if (t.name === 'sqft') {
      var cleaned = t.value.replace(/[^0-9]/g, '');
      if (t.value !== cleaned) t.value = cleaned;
      this.setAnswer('sqft', cleaned ? parseInt(cleaned, 10) : null);
      this._updateFooterEnabled();
    } else if (t.name === 'email') {
      this.state.emailValue = t.value;
    }
  };

  SystemSelectorWizard.prototype._updateFooterEnabled = function () {
    var vis = this.visibleKeys();
    var idx = Math.min(this.state.idx, Math.max(vis.length - 1, 0));
    var curKey = vis[idx];
    var curAnswered = this.answered(curKey);
    var allAnswered = vis.every(this.answered.bind(this));
    this.root.querySelectorAll('[data-action="next"]').forEach(function (btn) {
      btn.disabled = !curAnswered;
    });
    this.root.querySelectorAll('[data-action="view-compat"]').forEach(function (btn) {
      btn.disabled = !allAnswered;
      btn.classList.toggle('is-ready', allAnswered);
    });
  };

  SystemSelectorWizard.prototype.renderOptionCard = function (opt, selected) {
    var mediaClass = 'ssw-option__media';
    if (opt.diagram) mediaClass += ' ssw-option__media--diagram';
    if (opt.mediaMod) mediaClass += ' ssw-option__media--' + opt.mediaMod;
    var html = '';
    html +=
      '<button type="button" class="ssw-option' +
      (selected ? ' ssw-option--selected' : '') +
      (opt.logoUrl ? ' ssw-option--logo' : '') +
      '" data-action="select" data-value="' +
      esc(opt.id) +
      '" aria-pressed="' +
      (selected ? 'true' : 'false') +
      '">';
    html += '<span class="ssw-option__radio" aria-hidden="true">';
    if (selected) html += '<span class="ssw-option__radio-dot"></span>';
    html += '</span>';
    if (opt.swatchClass) {
      html +=
        '<span class="ssw-option__swatch ' + esc(opt.swatchClass) + '" aria-hidden="true"></span>';
    }
    if (opt.logoUrl) {
      html +=
        '<img class="ssw-option__logo" src="' +
        esc(opt.logoUrl) +
        '" alt="" width="120" height="34" loading="lazy">';
    } else if (opt.photoUrl) {
      html +=
        '<div class="' +
        mediaClass +
        '"><img src="' +
        esc(opt.photoUrl) +
        '" alt="" width="320" height="200" loading="lazy"></div>';
    } else if (opt.image) {
      html += '<div class="ssw-option__placeholder">[IMAGE: ' + esc(opt.image) + ']</div>';
    }
    if (opt.badge) html += '<span class="ssw-option__badge">' + esc(opt.badge) + '</span>';
    html += '<div class="ssw-option__title">' + esc(opt.title) + '</div>';
    (opt.captions || []).forEach(function (cap) {
      html += '<div class="ssw-option__cap">' + esc(cap) + '</div>';
    });
    html += '</button>';
    return html;
  };

  SystemSelectorWizard.prototype.render = function () {
    var st = this.state;
    var a = st.a;
    var config = this.config;
    this.pruneIncompatibleAnswers();
    this.applyAutoAnswers();
    var vis = this.visibleKeys();
    var idx = Math.min(st.idx, Math.max(vis.length - 1, 0));
    if (idx < 0) idx = 0;
    st.idx = idx;
    var curKey = vis[idx] || 'systemType';
    var meta = this.stepMeta(curKey);
    var calc = this.calc();
    var isMobile = st.isMobile;
    var isLast = idx === vis.length - 1;
    var curAnswered = this.answered(curKey);
    var allAnswered = vis.every(this.answered.bind(this));
    var firstUn = vis.findIndex(function (k) {
      return !this.answered(k);
    }.bind(this));
    var edge = (firstUn < 0 ? vis.length : firstUn) - 1;
    var showSkip = idx < edge;
    var nextLabel = isLast ? 'View My System →' : 'Next: ' + ((this.stepMeta(vis[idx + 1]) || {}).label || '');
    var showCalcBanner = !!calc && ['systemType', 'furnaceEff', 'cabinet', 'config', 'heatingStages', 'brand'].indexOf(curKey) !== -1;
    var summaryBodyOpen = isMobile ? st.mobileSummaryOpen : true;
    var brandImages = config.brandImages || {};

    var html = '';

    if (!st.showResults) {
      html += '<div class="ssw-flow">';

      html += '<div class="ssw-stepper">';
      html += '<div class="ssw-stepper__list" role="list">';
      for (var i = 0; i < vis.length; i++) {
        var done = i < idx;
        var active = i === idx;
        var clickable = i <= idx;
        html +=
          '<button type="button" role="listitem" class="ssw-stepper__item' +
          (active ? ' ssw-stepper__item--active' : '') +
          (done ? ' ssw-stepper__item--done' : '') +
          (clickable ? ' ssw-stepper__item--clickable' : '') +
          '" data-action="step" data-value="' +
          i +
          '"' +
          (clickable ? '' : ' disabled') +
          '>';
        html += '<span class="ssw-stepper__circle">' + (done ? '✓' : i + 1) + '</span>';
        html += '<span class="ssw-stepper__label">' + esc(this.stepMeta(vis[i]).label) + '</span>';
        html += '</button>';
      }
      html += '</div>';
      if (a.zone || a.sqft || a.insulation || a.systemType) {
        html += '<button type="button" class="ssw-reset" data-action="reset">↺ Start over</button>';
      }
      html += '</div>';

      html += '<div class="ssw-layout">';
      html += '<div class="ssw-panel">';
      html += '<div class="ssw-panel__head">';
      html += '<h3 class="ssw-panel__title">' + esc(meta.title) + '</h3>';
      if (showSkip) {
        html += '<button type="button" class="ssw-panel__skip" data-action="skip">Skip &amp; view all</button>';
      }
      html += '</div>';
      if (meta.sub) {
        html += '<p class="ssw-panel__sub">' + esc(meta.sub) + '</p>';
      }

      if (showCalcBanner) {
        var calcCooling = calc.hasCooling ? calc.ton + ' Ton · ' + formatNum(calc.btu) + ' BTU cooling' : '';
        var effPct = a.furnaceEff ? a.furnaceEff : 80;
        var calcHeating =
          formatNum(calc.reqHeat) +
          ' BTU/hr heat load → ' +
          formatNum(calc.furnaceInput) +
          ' BTU ' +
          (calc.hasFurnace ? 'furnace at ' + effPct + '% efficiency' : 'heating');
        var showCalcCooling = !a.systemType || calc.hasCooling;
        var showCalcHeating = !a.systemType || calc.hasFurnace;
        html += '<div class="ssw-calc">';
        html += '<div class="ssw-calc__row">';
        html += '<div>';
        html += '<div class="ssw-calc__eyebrow">Recommended for your home</div>';
        if (showCalcCooling && calcCooling) html += '<div class="ssw-calc__line">' + esc(calcCooling) + '</div>';
        if (showCalcHeating) html += '<div class="ssw-calc__line">' + esc(calcHeating) + '</div>';
        html += '</div>';
        html += '<button type="button" class="ssw-calc__adjust" data-action="toggle-override">Adjust size</button>';
        html += '</div>';
        if (st.overrideOpen) {
          var maxTon = a.systemType === 'hpFurnace' ? 3.5 : 5;
          html += '<div class="ssw-calc__overrides">';
          if (showCalcCooling) {
            html += '<label class="ssw-calc__field"><span>Tonnage:</span>';
            html += '<select name="tonnageOverride">';
            html +=
              '<option value="">Recommended (' +
              (calc.ton != null ? calc.ton : '—') +
              ' Ton)</option>';
            TONNAGE.filter(function (t) {
              return t.ton <= maxTon;
            }).forEach(function (t) {
              html +=
                '<option value="' +
                t.ton +
                '"' +
                (a.tonnageOverride === t.ton ? ' selected' : '') +
                '>' +
                t.ton +
                ' Ton · ' +
                formatNum(t.btu) +
                ' BTU</option>';
            });
            html += '</select></label>';
          }
          if (showCalcHeating) {
            var heatCap = a.systemType === 'hpFurnace' ? 100000 : 120000;
            var heatLabel = calc.hasFurnace ? 'Furnace BTU' : 'Heating BTU';
            html += '<label class="ssw-calc__field"><span>' + esc(heatLabel) + ':</span>';
            html += '<select name="heatingOverride">';
            html +=
              '<option value="">Recommended (' +
              (calc.furnaceInput ? formatNum(calc.furnaceInput) : '—') +
              ' BTU)</option>';
            HEATING.filter(function (h) {
              return h <= heatCap;
            }).forEach(function (h) {
              html +=
                '<option value="' +
                h +
                '"' +
                (a.heatingOverride === h ? ' selected' : '') +
                '>' +
                formatNum(h) +
                ' BTU</option>';
            });
            html += '</select></label>';
          }
          html += '</div>';
        }
        html += '</div>';
      }

      if (curKey === 'zone') {
        html += '<div class="ssw-zone-map">';
        html +=
          '<img src="' +
          esc(config.zoneMapUrl || '') +
          '" alt="' +
          esc(config.zoneMapAlt || 'US climate zone map') +
          '" width="960" height="540" loading="eager">';
        html += '</div>';
      }

      if (curKey === 'sqft') {
        html += '<div class="ssw-sqft">';
        html += '<label for="ssw-sqft-input">Home square footage</label>';
        html +=
          '<input id="ssw-sqft-input" name="sqft" type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" placeholder="e.g. 1850" value="' +
          esc(a.sqft ? String(a.sqft) : '') +
          '">';
        html +=
          '<div class="ssw-sqft__hint">Enter your total conditioned (heated &amp; cooled) square footage.</div>';
        html += '</div>';
        html += '<span class="ssw-options-heading">Insulation quality</span>';
      }

      var rawOpts = this.optionsFor(curKey) || [];
      var gridClass = 'ssw-options ssw-options--dense';
      if (curKey === 'systemType') gridClass = 'ssw-options ssw-options--system';
      if (curKey === 'heatingStages') gridClass = 'ssw-options ssw-options--stages';
      if (curKey === 'furnaceEff') gridClass = 'ssw-options ssw-options--efficiency';
      html += '<div class="' + gridClass + '" role="group" aria-label="' + esc(meta.title) + '">';
      for (var oi = 0; oi < rawOpts.length; oi++) {
        var o = rawOpts[oi];
        var key = curKey === 'sqft' ? 'insulation' : curKey;
        var selected = a[key] === o.id;
        var captions = o.captions || [];
        if (curKey === 'systemType' && o.included) {
          captions = [(o.id === 'furnace' ? '' : 'Includes: ') + o.included.join(', ')];
        }
        var logoUrl = this.optionLogoFor(curKey, o);
        var photoUrl = logoUrl ? null : this.optionImageFor(curKey, o);
        var isDiagram =
          curKey === 'config' || curKey === 'heatingStages' || curKey === 'furnaceEff';
        /* HVAC-065-DI — PVC vent cards: keep arrow at top visible */
        var mediaMod =
          curKey === 'furnaceEff' && o.id !== '80' ? 'pvc' : null;
        html += this.renderOptionCard(
          {
            id: o.id,
            title: o.title,
            captions: captions,
            image: photoUrl || logoUrl ? null : o.image || null,
            photoUrl: photoUrl,
            logoUrl: logoUrl,
            diagram: isDiagram,
            mediaMod: mediaMod,
            badge: o.badge || null,
            swatchClass: curKey === 'zone' ? 'ssw-option__swatch--' + o.id : null,
          },
          selected
        );
      }
      html += '</div>';

      if (curKey === 'cabinet') {
        var measureDesktop = config.cabinetMeasureBannerDesktop || config.cabinetMeasureBanner;
        var measureMobile = config.cabinetMeasureBannerMobile || measureDesktop;
        html += '<div class="ssw-helper">';
        if (measureDesktop) {
          html += '<div class="ssw-helper__banner">';
          html +=
            '<img class="ssw-helper__banner-img ssw-helper__banner-img--desktop" src="' +
            esc(measureDesktop) +
            '" alt="How to measure cabinet width" width="1200" height="420" loading="lazy">';
          if (measureMobile) {
            html +=
              '<img class="ssw-helper__banner-img ssw-helper__banner-img--mobile" src="' +
              esc(measureMobile) +
              '" alt="How to measure cabinet width" width="750" height="900" loading="lazy">';
          }
          html += '</div>';
          html +=
            '<p class="ssw-helper__measure"><strong>How to measure:</strong> Width is the left-to-right measurement across the front of the furnace. Measure straight across the front from the left side to the right side — not the depth (front to back) or the height (top to bottom).</p>';
          html += '<div class="ssw-helper__tip">';
          html +=
            '<p><strong>Tip:</strong> Use a tape measure. Measure only the metal cabinet (not including any trim or panels).</p>';
          html += '</div>';
        } else {
          html += '<div class="ssw-helper__title">How to Measure Cabinet Width</div>';
          html += '<div class="ssw-helper__body">';
          html +=
            '<p>Measure straight across the <strong>front</strong> of your existing indoor unit, left edge to right edge. This is the cabinet width — <strong>not</strong> the depth or the height.</p>';
          html += '</div>';
        }
        html += '</div>';
      }

      html += '</div>';

      html += '<aside class="ssw-rail">';
      html += '<div class="ssw-rail__card">';
      html +=
        '<button type="button" class="ssw-rail__head" data-action="toggle-summary" aria-expanded="' +
        (summaryBodyOpen ? 'true' : 'false') +
        '">';
      html += '<span>Your Selections</span>';
      if (isMobile) {
        html += '<span class="ssw-rail__caret" aria-hidden="true">' + (st.mobileSummaryOpen ? '▲' : '▼') + '</span>';
      }
      html += '</button>';
      html += '<div class="ssw-rail__body"' + (summaryBodyOpen ? '' : ' hidden') + '>';
      var summary = [];
      if (a.systemType) summary.push({ label: 'System Type', value: this.labelFor('systemType') });
      if (a.brand) summary.push({ label: 'Brand', value: this.labelFor('brand') });
      summary.push({ label: 'Zone', value: this.labelFor('zone') });
      summary.push({ label: 'Square Footage', value: this.labelFor('sqft') });
      summary.push({ label: 'Insulation', value: this.labelFor('insulation') });
      if (calc) {
        if (calc.hasCooling) {
          summary.push({
            label: 'Recommended Cooling',
            value: calc.ton + ' Ton / ' + formatNum(calc.btu) + ' BTU',
          });
        }
        if (calc.hasFurnace) {
          summary.push({
            label: 'Recommended Heating',
            value: formatNum(calc.furnaceInput) + ' BTU furnace',
          });
        }
      }
      var self = this;
      (BRANCH[a.systemType] || []).forEach(function (k) {
        if (vis.indexOf(k) !== -1) {
          summary.push({ label: self.stepMeta(k).label, value: self.labelFor(k) });
        }
      });
      summary.forEach(function (row) {
        html +=
          '<div class="ssw-rail__row"><span>' +
          esc(row.label) +
          '</span><span>' +
          esc(row.value) +
          '</span></div>';
      });
      html += '</div></div></aside>';
      html += '</div>';

      html += '<div class="ssw-footer ssw-footer--mobile">';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--primary' +
        (isLast ? ' is-last' : '') +
        '" data-action="next"' +
        (curAnswered ? '' : ' disabled') +
        '>' +
        esc(nextLabel) +
        '</button>';
      html += '<div class="ssw-footer__row">';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--back ssw-btn--ghost" data-action="back"' +
        (idx === 0 ? ' disabled' : '') +
        '>← Back</button>';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--compat' +
        (allAnswered ? ' is-ready' : '') +
        '" data-action="view-compat"' +
        (allAnswered ? '' : ' disabled') +
        '>Compatible systems</button>';
      html += '</div></div>';

      html += '<div class="ssw-footer ssw-footer--desktop">';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--back ssw-btn--ghost" data-action="back"' +
        (idx === 0 ? ' disabled' : '') +
        '>← Back</button>';
      html += '<div class="ssw-footer__row">';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--compat' +
        (allAnswered ? ' is-ready' : '') +
        '" data-action="view-compat"' +
        (allAnswered ? '' : ' disabled') +
        '>View compatible systems</button>';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--primary' +
        (isLast ? ' is-last' : '') +
        '" data-action="next"' +
        (curAnswered ? '' : ' disabled') +
        '>' +
        esc(nextLabel) +
        '</button>';
      html += '</div></div>';

      html += '</div>';
    } else {
      var kit = this.resolveKit();
      var c = kit.c;
      var spec = kit.spec || productDisplaySpecs(kit.product, c);
      var indoor = kit.st.indoor;
      var outdoor = kit.st.outdoor;
      var furnaceBtu = spec.furnaceInput || c.furnaceInput || c.reqHeat || 80000;
      var kitName = kit.product && kit.product.title ? kit.product.title : outdoorName(kit.st, c, kit.brandName);
      var bomItems = [];
      if (outdoor) {
        bomItems.push({ name: outdoor + ' — ' + spec.ton + ' Ton', note: formatNum(spec.btu || 0) + ' BTU' });
      }
      bomItems.push({
        name: indoor + (indoor === 'Furnace' ? ' — ' + (a.furnaceEff || '96') + '% AFUE' : ''),
        note: indoor === 'Furnace' ? formatNum(furnaceBtu) + ' BTU input' : '',
      });
      if (outdoor && indoor !== 'Coil') {
        bomItems.push({ name: 'Evaporator Coil', note: 'included' });
      }

      var priceLabel =
        kit.priceFormatted || (kit.price != null ? '$' + formatNum(kit.price) : 'See product');
      var monthlyBase = kit.price != null ? kit.price : kit.priceCents != null ? kit.priceCents / 100 : 0;
      var monthly = monthlyBase ? '$' + formatNum(Math.round((monthlyBase * 1.15) / 12)) : '—';
      var fallbackTypeImg =
        (config.systemTypeImages && config.systemTypeImages[a.systemType]) || null;

      html += '<div class="ssw-results">';
      html += '<h3 class="ssw-results__title">Your Recommended System</h3>';
      html +=
        '<p class="ssw-results__sub">' +
        esc(config.resultsSubtitle || 'A complete, single-brand kit sized to your home — ready to ship.') +
        '</p>';
      if (!kit.product) {
        html +=
          '<p class="ssw-results__sub">No exact catalog match for every filter yet — browse compatible systems or adjust size.</p>';
      }
      html += '<div class="ssw-results__grid">';
      html += '<div class="ssw-kit">';
      html += '<div class="ssw-kit__photo">';
      if (kit.imageUrl) {
        html +=
          '<img src="' +
          esc(kit.imageUrl) +
          '" alt="' +
          esc(kit.imageAlt || kitName) +
          '" width="800" height="600" loading="lazy">';
      } else if (fallbackTypeImg) {
        html +=
          '<img src="' +
          esc(fallbackTypeImg) +
          '" alt="" width="400" height="300" loading="lazy">';
      } else {
        html += '<div class="ssw-kit__photo-ph">' + esc(kit.st.image) + '</div>';
      }
      html += '</div>';
      html += '<div class="ssw-kit__brand">' + esc(kit.brandName) + '</div>';
      html += '<h4 class="ssw-kit__name">' + esc(kitName) + '</h4>';
      html +=
        '<div class="ssw-kit__model">Model no. <strong>' + esc(kit.model) + '</strong></div>';
      if (kit.productUrl) {
        html +=
          '<p class="ssw-kit__details"><button type="button" class="ssw-panel__skip" data-action="view-product">View product details →</button></p>';
      }
      html +=
        '<p class="ssw-kit__edit"><button type="button" class="ssw-results__edit" data-action="edit">← Edit my selections</button></p>';
      html += '<div class="ssw-bom"><div class="ssw-bom__title">Primary Equipment</div>';
      bomItems.forEach(function (it) {
        html +=
          '<div class="ssw-bom__row"><span>' +
          esc(it.name) +
          '</span><span>' +
          esc(it.note) +
          '</span></div>';
      });
      html += '</div>';
      html += '<div class="ssw-bom"><div class="ssw-bom__title">Your Configuration</div>';
      var configRows = [
        { label: 'Zone', value: this.labelFor('zone') },
        { label: 'Square Footage', value: this.labelFor('sqft') },
        { label: 'Insulation', value: this.labelFor('insulation') },
      ];
      var wizardSelf = this;
      (BRANCH[a.systemType] || []).forEach(function (k) {
        if (vis.indexOf(k) !== -1) {
          configRows.push({ label: wizardSelf.stepMeta(k).label, value: wizardSelf.labelFor(k) });
        }
      });
      configRows.forEach(function (row) {
        html +=
          '<div class="ssw-bom__row"><span>' +
          esc(row.label) +
          '</span><span>' +
          esc(row.value) +
          '</span></div>';
      });
      html += '</div></div>';

      html += '<div class="ssw-price">';
      html += '<div class="ssw-price__label">Complete system price</div>';
      html += '<div class="ssw-price__value">' + esc(priceLabel) + '</div>';
      html += '<div class="ssw-price__finance">';
      html += '<span>From <strong>' + esc(monthly) + '</strong>/mo with</span>';
      html += '<span class="ssw-shop-pay">shop <span>Pay</span></span>';
      html +=
        '<button type="button" class="ssw-price__finance-link" data-action="open-finance">Check your purchasing power</button>';
      html += '</div>';
      html += '<div class="ssw-price__atc-anchor">';
      html += '<div class="ssw-price__actions-sentinel" aria-hidden="true"></div>';
      html += '<div class="ssw-price__actions">';
      html +=
        '<button type="button" class="ssw-btn ssw-btn--primary' +
        (st.cartAdded ? ' is-last' : '') +
        '" data-action="add-cart"' +
        (!kit.variantId && !kit.productUrl ? ' disabled' : '') +
        '>' +
        (st.cartAdded ? '✓ Added to Cart' : kit.variantId ? 'Add to Cart' : 'View product') +
        '</button>';
      if (st.cartError) {
        html += '<p class="ssw-cart-error" role="alert">' + esc(st.cartError) + '</p>';
      }
      html += '</div></div>';
      html +=
        '<div class="ssw-price__stock"><span class="ssw-price__stock-dot" aria-hidden="true"></span><span>' +
        (kit.available || !kit.product ? 'In Stock &amp; Ready to Ship' : 'Check availability on product page') +
        '</span></div>';
      html += '<div class="ssw-price__help">';
      html += '<span aria-hidden="true">📞</span>';
      html += '<div><div class="ssw-price__help-label">Last-minute help?</div>';
      html +=
        '<a href="' +
        esc(config.phoneHref || 'tel:+18667181799') +
        '">Call ' +
        esc(config.phoneDisplay || '1866-718-1799') +
        '</a></div></div>';
      html += '<div class="ssw-email">';
      html += '<div class="ssw-email__title">Email my results</div>';
      html +=
        '<div class="ssw-email__text">Get this system spec and pricing sent to your inbox to review or share later.</div>';
      html += '<div class="ssw-email__fields">';
      html +=
        '<label class="visually-hidden" for="ssw-email">Email</label>';
      html +=
        '<input id="ssw-email" name="email" type="email" placeholder="you@email.com" value="' +
        esc(st.emailValue) +
        '" autocomplete="email">';
      html +=
        '<button type="button" class="ssw-email__btn" data-action="email"' +
        (st.emailSending ? ' disabled' : '') +
        '>' +
        (st.emailSending ? 'Sending…' : st.emailSent ? '✓ Sent' : 'Email My Results') +
        '</button>';
      html += '</div>';
      if (st.emailError) {
        html += '<div class="ssw-email__note ssw-email__note--error" role="alert">' + esc(st.emailError) + '</div>';
      } else if (st.emailSent) {
        html +=
          '<div class="ssw-email__note">✓ Results emailed to ' + esc(st.emailValue) + '</div>';
        html +=
          '<div class="ssw-email__note ssw-email__note--hint">Check your inbox, <strong>promotions</strong> or <strong>spam</strong>. It might take a few minutes.</div>';
      }
      html += '</div></div></div>';

      if (st.financeOpen) {
        var financeBase = monthlyBase || 0;
        var plans = [3, 12].map(function (mo) {
          var apr = 0.15;
          var interest = Math.round(financeBase * apr * (mo / 12));
          var total = financeBase + interest;
          var per = mo ? total / mo : 0;
          return {
            headline:
              '$' +
              per.toLocaleString(undefined, { maximumFractionDigits: 2 }) +
              ' every month for ' +
              mo +
              ' months',
            apr: '15%',
            interest: '$' + formatNum(interest),
            total: '$' + formatNum(total),
          };
        });
        html += '<div class="ssw-modal" data-action="close-finance" role="dialog" aria-modal="true" aria-label="Shop Pay sample plans">';
        html += '<div class="ssw-modal__dialog" data-stop>';
        html += '<div class="ssw-modal__head">';
        html += '<div class="ssw-modal__title-row">';
        html += '<span class="ssw-shop-pay">shop <span>Pay</span></span>';
        html += '<span class="ssw-modal__title">Get it now, pay later</span>';
        html += '</div>';
        html +=
          '<button type="button" class="ssw-modal__close" data-action="close-finance" aria-label="Close">✕</button>';
        html += '</div>';
        html +=
          '<div class="ssw-modal__lead">Sample plans for <strong>' +
          esc(priceLabel) +
          '</strong> purchase</div>';
        html += '<div class="ssw-modal__plans">';
        plans.forEach(function (p) {
          html += '<div class="ssw-modal__plan">';
          html += '<div class="ssw-modal__plan-headline">' + esc(p.headline) + '</div>';
          html +=
            '<div class="ssw-modal__plan-row"><span>Interest (' +
            esc(p.apr) +
            ' APR)</span><span>' +
            esc(p.interest) +
            '</span></div>';
          html +=
            '<div class="ssw-modal__plan-row ssw-modal__plan-row--strong"><span>Total</span><span>' +
            esc(p.total) +
            '</span></div>';
          html += '</div>';
        });
        html += '</div>';
        html +=
          '<button type="button" class="ssw-modal__cta" data-action="close-finance">Continue to checkout</button>';
        html +=
          '<div class="ssw-modal__note">Checking your qualification won\'t affect your credit.</div>';
        html +=
          '<div class="ssw-modal__legal">Estimated payments exclude taxes and shipping. Rates range from 0–36% APR and are provided by our lending partners, subject to eligibility. A down payment may be required. Sample math is a placeholder for CRO review.</div>';
        html += '</div></div>';
      }

      html += '</div>';
    }

    this.root.innerHTML = html;
    this.persistState();
    this.bindStickyAtc();
    this.restoreSelectedOptionScroll();

    var dialog = this.root.querySelector('.ssw-modal__dialog');
    if (dialog) {
      dialog.addEventListener('click', function (ev) {
        ev.stopPropagation();
      });
    }

    if (st.showResults) {
      var emailInput = this.root.querySelector('#ssw-email');
      if (emailInput && document.activeElement !== emailInput && st.emailValue) {
        // keep value; avoid stealing focus on every render unless needed
      }
    } else if (curKey === 'sqft') {
      var sqftInput = this.root.querySelector('#ssw-sqft-input');
      if (sqftInput && document.activeElement === sqftInput) {
        var pos = sqftInput.value.length;
        sqftInput.focus();
        sqftInput.setSelectionRange(pos, pos);
      }
    }
  };

  function readConfig(section) {
    var el = section.querySelector('[data-wizard-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return {};
    }
  }

  function boot() {
    var section = document.querySelector('[data-system-selector-wizard]');
    if (!section) return;
    var root = section.querySelector('[data-wizard-root]');
    if (!root) return;
    var wizard = new SystemSelectorWizard(root, readConfig(section));
    wizard.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
